import React, { useEffect } from "react";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import WalletMainScreen from "../../container/Ucash";

const UCash = () => {
  useEffect(() => {
    triggerLogEvent(analytics, "w_discovered");
  }, []);

  return <WalletMainScreen />;
};

export default UCash;
